import React from "react";
import { pageNotFound } from "../../assets";
import useDeviceType from "../../custom-hooks/DeviceType";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NoRouteFoundScreen = () => {
  const navigate = useNavigate();
  const deviceType = useDeviceType();
  return (
    <div className="flex-1 min-h-0 flex justify-center items-center flex-col">
      <img
        src={pageNotFound}
        alt="page-not-found"
        className={deviceType === "mobile" ? "w-[80%]" : "w-[50%]"}
      />
      <Typography className="cursor-pointer" onClick={() => navigate("/login")}>
        Back To Login
      </Typography>
    </div>
  );
};

export default NoRouteFoundScreen;
